import React from "react";
import { Container, ContentWithPaddingXl } from "includes/Layouts";
import tw from "twin.macro";
import { SectionHeading } from "includes/Heading";
const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;


export default class Page extends React.Component {

  title = '';
  html = '';

  constructor(props) {
    super(props);
    this.title = props.fieldData.title;
    this.html = props.fieldData.html;
  }

  rawMarkup(){
    return { __html: this.html };
  }
  render() {
    return (
        <Container className="terms-wrapper">
          <ContentWithPaddingXl>
            <HeadingRow>
              <Heading>{this.title}</Heading>
            </HeadingRow>
           <div dangerouslySetInnerHTML={this.rawMarkup()} />
          </ContentWithPaddingXl>
        </Container>
    );
  }
}

